module.exports = __webpack_public_path__ + "img/moon-logo-white.aca2eda2.svg";